// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */
import { METHODOLOGY_VERSION,                       } from './methodology.mjs';
import {
  calculatePowerfulNumber,


} from './profile.mjs';





















































/**
 * Builds the free report contract. Karmic debt values and their source never
 * cross this boundary; only the existence of additional paid insight does.
 */
export function createSimpleReportProjection(
  nameProfile             ,
  dateProfile             ,
)                         {
  return {
    methodologyVersion: METHODOLOGY_VERSION,
    numbers: {
      destiny: nameProfile.destiny.value,
      origin: dateProfile.origin.value,
      soul: nameProfile.soul.value,
      personality: nameProfile.personality.value,
      powerful: calculatePowerfulNumber(
        nameProfile.destiny.value,
        dateProfile.origin.value,
      ).value,
      birth: dateProfile.birthNumber,
    },
    hasKarmicInsight: Boolean(
      nameProfile.destiny.karmicDebt || dateProfile.origin.karmicDebt,
    ),
  };
}

/**
 * Builds the free cycles contract without dates, raw totals or karmic fields.
 * Each challenge is paired with the pinnacle period at the same index.
 */
export function createSimpleCyclesProjection(
  dateProfile             ,
)                         {
  function projectPeriod(
    periodIndex               ,
    index               ,
  )                              {
    const pinnacle = dateProfile.pinnacles[periodIndex];
    return {
      index,
      pinnacle: pinnacle.number,
      challenge: dateProfile.challenges[periodIndex].value,
      startsAtAge: pinnacle.startsAtAge,
      endsAtAgeExclusive: pinnacle.endsAtAgeExclusive,
      isCurrent: dateProfile.currentPinnacle === index,
    };
  }

  return {
    methodologyVersion: METHODOLOGY_VERSION,
    personalYear: {
      cycleYear: dateProfile.personalCycles.cycleYear,
      number: dateProfile.personalCycles.personalYear.value,
    },
    personalMonth: {
      number: dateProfile.personalCycles.personalMonth.value,
      calendarYear: dateProfile.personalCycles.currentMonth.year,
      calendarMonth: dateProfile.personalCycles.currentMonth.month,
      currentDay: dateProfile.personalCycles.currentMonth.currentDay,
      dailyNumbers: dateProfile.personalCycles.currentMonth.dailyNumbers.map(
        (calculation) => calculation?.value ?? null,
      ),
    },
    periods: [
      projectPeriod(0, 1),
      projectPeriod(1, 2),
      projectPeriod(2, 3),
      projectPeriod(3, 4),
    ],
  };
}

/** Build only after paid entitlement has been verified. */
export function createPaidKarmicProjection(
  nameProfile             ,
  dateProfile             ,
)                       {
  return {
    methodologyVersion: METHODOLOGY_VERSION,
    destiny: nameProfile.destiny.karmicDebt,
    origin: dateProfile.origin.karmicDebt,
    missingLessons: [...nameProfile.karma.missing],
    excesses: [...nameProfile.karma.excess],
  };
}
